export default {

    data() {
        return {
            pagination: {},
            selectedPage: 1
        }
    }

}



// WEBPACK FOOTER //
// ./app/statamic/resources/js/components/Paginates.js